import z from 'zod';

export interface HospitalizationUpdateRequest {
  note?: string;
  requiresFollowUp?: boolean;
}

export const CreateHospitalizationRequestSchema = z.object({
  memberId: z.string().min(1, 'Member ID is required'),
  hospital: z.string().optional(),
  hospitalInfo: z.string().optional(),
  note: z.string().optional(),
  // Admit
  admitComplaint: z.string().optional(),
  admitNotificationTime: z.string().optional(),
  admitType: z.string().optional(),
  admitDate: z.string().optional(),
  // Discharge
  dischargeNotificationTime: z.string().optional(),
  dischargeDate: z.string().optional(),
  dischargeDisposition: z.string().optional(),
  // Follow Up
  followUpDate: z.string().optional(),
  followUpType: z.string().optional(),
  requiresFollowUp: z.boolean().optional(),
  expectedSurveyCompletion: z.string().optional(),
  isEnrolledInBehavioralHealth: z.boolean().optional(),
  isAssumed: z.boolean().optional(),
  hospitalizationEventId: z.string().optional(),
});

export type CreateHospitalizationRequest = z.infer<
  typeof CreateHospitalizationRequestSchema
>;
